/* global gigya */

export default {
    render(h) {
        const ratings = h(
            'div', {
                class: 'c-recipe__ratings',
                attrs: {
                    id: 'ratingsDiv'
                }
            }
        );

        const comments = h(
            'div', {
                class: 'c-recipe__comments',
                attrs: {
                    id: 'commentsDiv'
                }
            }
        );

        const container = h(
            'div', {
                class: 'c-recipe__social'
            }, [ratings, comments]
        );

        return container;
    },
    props: {
        ratingsCategoryId: {
            type: String,
            required: true
        },
        ratingsStreamId: {
            type: String,
            required: true
        },
        commentsCategoryId: {
            type: String,
            required: true
        },
        commentsStreamId: {
            type: String,
            required: true
        },
        commentsStreamTags: {
            type: String,
            required: true
        },
        hideShareButtons: {
            type: Boolean,
            default: false
        },
        showReadReviewsLink: {
            type: Boolean,
            default: false
        },
        showCommentButton: {
            type: Boolean,
            default: true
        },
        writeReviewLabel: {
            type: String,
            default: 'Write Review'
        },
        hideRatingToolLabel: {
            type: String,
            default: 'Hide Rating'
        }
    },
    mounted() {
        const ratingsParams = {
            categoryID: this.ratingsCategoryId,
            streamID: this.ratingsStreamId,
            containerID: 'ratingsDiv',
            showReadReviewsLink: this.showReadReviewsLink,
            showCommentButton: this.showCommentButton,
            onAddReviewClicked: () => {
                const commentsElement = document.querySelector('#commentsDiv');
                const reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? this.hideRatingToolLabel : this.writeReviewLabel;
            },
            onReadReviewsClicked: () => {
                const commentsElement = document.querySelector('#commentsDiv');
                const reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? this.hideRatingToolLabel : this.writeReviewLabel;
            },
            onLoad: () => {
                const reviewButton = document.querySelector('.gig-rating-writeYourReview');

                reviewButton.innerHTML = this.writeReviewLabel;
            }
        };

        const ratingsElement = document.querySelector('#ratingsDiv');

        ratingsElement.classList.toggle('is-visible', this.showCommentButton || this.showReadReviewsLink);

        gigya.comments.showRatingUI(ratingsParams);

        const commentsParams = {
            categoryID: this.commentsCategoryId,
            streamID: this.commentsStreamId,
            containerID: 'commentsDiv',
            hideShareButtons: this.hideShareButtons,
            version: 2,
            disabledShareProviders: '*',
            streamTags: this.commentsStreamTags
        };

        gigya.comments.showCommentsUI(commentsParams);
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-recipe-social.js